import React from 'react';

const CountdownBadge = ({ targetDate, size = 'md' }) => {
  const parseLocalDate = (dateStr) => {
    if (!dateStr) return null;
    if (typeof dateStr === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
      const [y, m, d] = dateStr.split('-').map(Number);
      return new Date(y, m - 1, d);
    }
    return new Date(dateStr);
  };

  const eventDate = parseLocalDate(targetDate);
  if (!eventDate) return null;

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const eventDay = new Date(eventDate);
  eventDay.setHours(0, 0, 0, 0);

  const diffTime = eventDay - today;
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  let label, icon;
  if (diffDays < 0) {
    label = 'In Progress';
    icon = (
      <span className="relative flex h-2 w-2">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-blue-400 opacity-75"></span>
        <span className="relative inline-flex rounded-full h-2 w-2 bg-blue-500"></span>
      </span>
    );
  } else if (diffDays === 0) {
    label = 'Today!';
    icon = <span className="text-xs">🔥</span>;
  } else if (diffDays === 1) {
    label = '1 day to go';
    icon = null;
  } else {
    label = `${diffDays} days to go`;
    icon = null;
  }

  const sizeClasses = size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-3 py-1 text-xs';

  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full font-semibold ${sizeClasses} bg-amber-50 dark:bg-amber-900/20 text-amber-700 dark:text-amber-300 border border-amber-200 dark:border-amber-800/50`}>
      {icon}
      {label}
    </span>
  );
};

export default CountdownBadge;
